<template>
  <layout :titlePage="titlePage" :route="{ name: 'carteira' }">
    <section class="c-validation-email">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column is-two-fifths">
          <base-header-page
            class="c-base-header-page--full has-text-white has-background-success has-text-centered"
            :class="{ 'has-background-error': error }"
          >
            <base-icon
              :name="headerIcon"
              class="c-receipt__header-icon"
              width="50"
              height="50"
            />
            <p class="c-validation-email__title">
              <strong class="has-text-white is-size-6 is-size-5-tablet">
                <div class="c-validation-email__title" v-html="title">
                  {{ title }}
                </div>
              </strong>
            </p>
          </base-header-page>
        </div>
        <div class="column">
          <div class="c-receipt__wrapper has-text-centered">
            <img :src="logoCasar" class="c-validation-email__logo" />
            <div v-if="!this.error" class="c-validation-email__content">
              <p class="has-text-left">
                Agora é só aguardar! Até o final do próximo dia útil a sua chave
                PIX será validada e você poderá utilizá-la para resgatar os
                valores ganhos na sua lista de presentes. Se você solicitou o
                cadastro da sua chave PIX há mais de 1 dia útil é possível que
                ela já esteja aprovada
                <span
                  ><img
                    src="https://a.slack-edge.com/production-standard-emoji-assets/13.0/google-medium/1f603.png"
                /></span>
              </p>
              <br />
              <p class="has-text-left">
                Para acompanhar o status desta solicitação acesse a sua
                <a href="/carteira/saque-opcoes">carteira</a> e clique sobre a
                sua chave PIX.
              </p>
            </div>
            <div v-else class="c-validation-email__content">
              <p class="has-text-left">
                <strong
                  >O link para confirmação do cadastro da sua chave PIX
                  expirou!</strong
                >
              </p>
              <br />
              <p class="has-text-left">
                Para solicitar o reenvio do e-mail de confirmação acesse a sua
                <a href="/carteira/saque-opcoes">carteira</a> e clique sobre a
                sua chave PIX.
              </p>
              <br />
              <p class="has-text-left">
                Em seguida, basta clicar no botão "reenviar e-mail" e conferir o
                recebimento em seu e-mail de cadastro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import axios from 'axios'

import layout from '@/layouts/Default.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'

import logoCasar from '@/assets/img/logo-principal.png'

const API_URL = process.env.VUE_APP_API_URL

export default {
  components: {
    layout,
    BaseHeaderPage,
  },

  metaInfo: {
    title: 'Comprovante de solicitação de transferência',
  },

  computed: {
    title() {
      return this.error
        ? 'Link de<br>confirmação<br>expirado!'
        : 'Solicitação de cadastro de<br>chave Pix confirmada!'
    },

    headerIcon() {
      return this.error ? 'painel/alert-icon' : 'painel/check-icon'
    },

    titlePage() {
      return 'Validação chave PIX'
    },
  },

  data() {
    return {
      error: true,
      logoCasar,
    }
  },

  async created() {
    this.loading = true
    let token = this.$route.params.token
    let idWed = this.$route.params.id

    if (!token || !idWed) {
      const tokenUrl = new URLSearchParams(window.location.search)
      token = tokenUrl.get('token')
      idWed = tokenUrl.get('id')
    }

    if (token && idWed) {
      const instance = axios.create({
        baseURL: API_URL + '/v1/wallets/' + idWed,
      })

      instance.defaults.headers.common['Authorization'] = `Bearer ${token}`

      instance
        .put('/bank-account/verification')
        .then(() => {
          this.error = false
        })
        .catch((error) => {
          console.error(error)
          this.error = true
        })
    } else {
      this.error = true
    }

    this.loading = true
  },
}
</script>

<style lang="scss">
.c-receipt {
  &__header-icon {
    @media (min-width: $tablet) {
      width: 110px;
      height: 110px;
    }
  }

  &__wrapper {
    padding: 2em 12px 0;
    margin: 0 auto;
    max-width: 420px;
  }

  .c-base-summary {
    margin: 2em auto;

    &__wrapper {
      padding: 18px 0;
      margin: 0 auto;
      max-width: 320px;
    }

    &__content-bordered {
      position: relative;
      &:before {
        content: '';
        @include position(absolute, auto, 0, -6px, auto);
        width: 100px;
        height: 1px;
        background-color: $gray-3;
      }
    }
  }
}

.c-validation-email {
  &__title {
    width: fit-content;
    margin: 0 auto;
    text-align: left;
  }

  &__logo {
    margin-bottom: 16px;
  }

  &__content {
    position: relative;

    p {
      span {
        position: absolute;
        margin-left: 5px;
      }
    }

    a {
      font-weight: bold;
    }
  }
}

.typeform-share-hidden {
  display: none;
}
</style>
